import {SlButton, SlDialog, SlInput} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {ReloadManager} from '../cmsmodule/reloadManager';

export class InternetListManager {
    private readonly viewRoot: HTMLElement;

    constructor(viewroot: HTMLElement) {
        this.viewRoot = viewroot;

        this.registerEventChooseAddressList();
        this.registerEventOpenSpeedHelp();
        this.registerEventOpenDSLProviderHelp();
        this.registerEventSubmitButton();
    }

    private registerEventChooseAddressList(): void {
        const chooseDSLAddresses = this.viewRoot.querySelectorAll<HTMLAnchorElement>('.chooseDSLAddress');

        if (chooseDSLAddresses.length === 0) {
            return;
        }
        chooseDSLAddresses.forEach((chooseDSLAddress) => {
            chooseDSLAddress.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const form = chooseDSLAddress.closest('form') as HTMLFormElement;
                if (!form) {
                    return;
                }

                const zip = notNull(form.querySelector('[name="availability[zip]"]')) as HTMLInputElement;
                zip.value = notNull(chooseDSLAddress.dataset.zip);

                const city = notNull(form.querySelector('[name="availability[city]"]')) as HTMLInputElement;
                city.value = notNull(chooseDSLAddress.dataset.city);

                const street = notNull(form.querySelector('[name="availability[street]"]')) as HTMLInputElement;
                street.value = notNull(chooseDSLAddress.dataset.street);

                const street_no = notNull(form.querySelector('[name="availability[street_no]"]')) as HTMLInputElement;
                street_no.value = notNull(chooseDSLAddress.dataset.street_no);

                const supplement = notNull(form.querySelector('[name="availability[supplement]"]')) as HTMLInputElement;
                supplement.value = notNull(chooseDSLAddress.dataset.supplement);

                const reloadManager = new ReloadManager();
                reloadManager.reloadModule(form, true);
            });
        });
    }

    private registerEventOpenSpeedHelp(): void {
        const openDSLSpeedHelp = this.viewRoot.querySelector('.openDSLSpeedHelp') as HTMLAnchorElement;
        const dialogDSLSpeedHelp = this.viewRoot.querySelector('#openDSLSpeedHelp') as SlDialog;
        if (openDSLSpeedHelp && dialogDSLSpeedHelp) {
            openDSLSpeedHelp.addEventListener('click', (e) => {
                e.preventDefault();
                dialogDSLSpeedHelp.show();
            });
        }
    }

    private registerEventOpenDSLProviderHelp(): void {
        const openDSLProviderHelp = this.viewRoot.querySelector('.openDSLProviderHelp') as HTMLAnchorElement;
        const dialogDSLProviderHelp = this.viewRoot.querySelector('#openDSLProviderHelp') as SlDialog;
        if (openDSLProviderHelp && dialogDSLProviderHelp) {
            openDSLProviderHelp.addEventListener('click', (e) => {
                e.preventDefault();
                dialogDSLProviderHelp.show();
            });
        }
    }

    private registerEventSubmitButton(): void {
        const dslAvailabilitySubmitButton = this.viewRoot.querySelector('form.form-standard.consult-availability sl-button[type="submit"]') as SlButton;

        if (!dslAvailabilitySubmitButton) {
            return;
        }

        dslAvailabilitySubmitButton.addEventListener('click', (event) => {
            event.preventDefault();
            // Simple Validierung, da es sonst dazu kommen kann, dass die loading Klasse gesetzt wird,
            // obwohl das Formular nicht korrekt ausgefuellt wurde. In dem Fall geht der Ladescreen
            // fuer den Benutzer nicht mehr weg.
            // Testplan: auf https://www.logitel.de/internet.html auf "weiter zum naechsten Schritt" klicken
            // Das Formular darf nicht abgeschickt werden und die loading Klasse darf nicht gesetzt werden
            const formFields = notNull(dslAvailabilitySubmitButton.closest('form')).querySelectorAll<SlInput>('sl-input[required]');
            let valid = true;
            // fragt alle required-shoelace input Felder ab und schaut, ob sie mit etwas ausgefuellt sind
            if (formFields.length > 0) {
                formFields.forEach((formField) => {
                    if (formField.value === '') {
                        valid = false;

                        formField.removeAttribute('data-valid');
                        formField.removeAttribute('data-user-valid');
                        formField.setAttribute('data-invalid', 'invalid');
                        formField.setAttribute('data-user-invalid', 'invalid');
                    }
                });
            }
            if (valid) {
                document.body.classList.add('loadingdsl');
            }
        });
    }
}
